// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ZeRW57PNaWpYVsw6JlaC {
  width: 100%;
  display: grid;
  grid-template-columns: 3vw 17vw 5vw 5vw;
  padding: 1vmin 0;
  color: var(--text-light);
  background-color: var(--tan-1);
  border-top: 0.1vmin solid var(--tan-3);
  font-size: 1.5vw;
  margin-right: -1vmin;
}

.ZeRW57PNaWpYVsw6JlaC:last-child {
  border-bottom: 0.1vmin solid var(--tan-3);
}

.ZeRW57PNaWpYVsw6JlaC .Z_MQzAiRjTlxboCrh9om {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 1.3vw;
}

.ZeRW57PNaWpYVsw6JlaC .iZ6oJDRJlBAjRnxPhUy5 {
  display: flex;
  justify-content: flex-end;
  align-content: flex-end;
  font-size: 1.2vw;
  margin-left: 3vmin;
  margin-right: -2vmin;
}

.ZeRW57PNaWpYVsw6JlaC button {
  margin: 0;
}

.ZeRW57PNaWpYVsw6JlaC .eH_p_tufby7PkGez8Lug {
  height: 4vw;
  width: 4vw;
  background-color: var(--tan-2);
  border-radius: 2vmin;
}

sub {
  font-size: small;
  color: var(--text-light);
  font-style: italic;
}`, "",{"version":3,"sources":["webpack://./src/components/LineItem/LineItem.module.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,aAAA;EACA,uCAAA;EACA,gBAAA;EACA,wBAAA;EACA,8BAAA;EACA,sCAAA;EACA,gBAAA;EACA,oBAAA;AACJ;;AAEA;EACI,yCAAA;AACJ;;AAEA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,aAAA;EACA,yBAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;AACJ;;AAEA;EACI,SAAA;AACJ;;AAEA;EACI,WAAA;EACA,UAAA;EACA,8BAAA;EACA,oBAAA;AACJ;;AAEA;EACI,gBAAA;EACA,wBAAA;EACA,kBAAA;AACJ","sourcesContent":[".LineItem {\n    width: 100%;\n    display: grid;\n    grid-template-columns: 3vw 17vw 5vw 5vw;\n    padding: 1vmin 0;\n    color: var(--text-light);\n    background-color: var(--tan-1);\n    border-top: .1vmin solid var(--tan-3);\n    font-size: 1.5vw;\n    margin-right: -1vmin;\n}\n\n.LineItem:last-child {\n    border-bottom: .1vmin solid var(--tan-3);\n}\n\n.LineItem .qty {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    font-size: 1.3vw;\n}\n\n.LineItem .extPrice {\n    display: flex;\n    justify-content: flex-end;\n    align-content: flex-end;\n    font-size: 1.2vw;\n    margin-left: 3vmin;\n    margin-right: -2vmin;\n}\n\n.LineItem button {\n    margin: 0;\n}\n\n.LineItem .logo {\n    height: 4vw;\n    width: 4vw;\n    background-color: var(--tan-2);\n    border-radius: 2vmin;\n}\n\nsub {\n    font-size: small;\n    color: var(--text-light);\n    font-style: italic;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"LineItem": `ZeRW57PNaWpYVsw6JlaC`,
	"qty": `Z_MQzAiRjTlxboCrh9om`,
	"extPrice": `iZ6oJDRJlBAjRnxPhUy5`,
	"logo": `eH_p_tufby7PkGez8Lug`
};
export default ___CSS_LOADER_EXPORT___;
